import React from "react";
export const SwitchButtonLarge = ({ isOn, onClick, color }) => (
  <div
    role="button"
    className={`toggle-switch ${isOn ? "on" : "off"}`}
    onClick={onClick}
    style={{
      width: "50px",
      height: "25px",
      backgroundColor: isOn ? color : "#ccc",
      borderRadius: "13px",
      cursor: "pointer",
      position: "relative",
    }}
  >
    <div
      style={{
        width: "23px",
        height: "23px",
        backgroundColor: "#fff",
        borderRadius: "50%",
        position: "absolute",
        top: "50%",
        left: isOn ? "25px" : "0px",
        transform: "translateY(-50%)",
        transition: "left 0.3s ease",
      }}
    />
  </div>
);

export const SwitchButtonMedium = ({ isOn, onClick, color }) => (
  <div
    role="button"
    className={`toggle-switch ${isOn ? "on" : "off"}`}
    onClick={onClick}
    style={{
      width: "40px",
      height: "20px",
      backgroundColor: isOn ? color : "#ccc",
      borderRadius: "10px",
      cursor: "pointer",
      position: "relative",
    }}
  >
    <div
      style={{
        width: "19px",
        height: "19px",
        backgroundColor: "#fff",
        borderRadius: "50%",
        position: "absolute",
        top: "50%",
        left: isOn ? "20px" : "0px",
        transform: "translateY(-50%)",
        transition: "left 0.3s ease",
      }}
    />
  </div>
);
